import * as React from "react";
import Box from "@mui/material/Box";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import Modal from "@mui/material/Modal";
import { AuthServices } from "../services/AuthServices";
import { logOut } from "../config/user";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import CloseIcon from "../assets/crossIcon.svg";
import PdfIcon from "../assets/pdfIcon.png";
import "./uploadImage.scss";
import { toast } from "react-toastify";
import { PDFDocument, EncryptedPDFError } from "pdf-lib";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "720px",
  height: "560px",
  borderRadius: "16px",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
};

export default function UploadImage({ setFieldValue, fieldName }) {
  const [open, setOpen] = React.useState(false);
  const [docUrl, setDocUrl] = React.useState("");
  const [uploadstatus, setuploadstatus] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const fileInputRef = React.useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const getFileType = (url) => {
    if (!url) return "unknown";

    const extension = url.split(".").pop().split("?")[0].toLowerCase();

    if (["jpg", "jpeg", "png"].includes(extension)) {
      return "image";
    }

    if (extension === "pdf") {
      return "pdf";
    }

    return "unknown";
  };

  const isPasswordProtectedPdf = async (file) => {
    try {
      const arrayBuffer = await file.arrayBuffer();
      await PDFDocument.load(arrayBuffer);
      return { protected: false };
    } catch (err) {
      if (err instanceof EncryptedPDFError) {
        return { protected: true };
      }
      console.error("PDF check failed (treating as unverifiable):", err);
      return { protected: false, unverifiable: true };
    }
  };

  const uploadImage = async (e) => {
    if (e.target.files[0].size > 5242880) {
      window.alert("Please upload a file smaller than 2 MB");
    } else {
      try {
        const file = e.target.files[0];
        if (file) {
          const allowedTypes = [
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/pdf",
          ];
          const allowedExtensions = /\.(jpe?g|png|pdf)$/i;

          const isValidType =
            allowedTypes.includes(file.type) &&
            allowedExtensions.test(file.name);

          if (!isValidType) {
            toast.error("Only JPG, JPEG, and PNG files are allowed");
            return;
          }

          if (file.type === "application/pdf") {
            const result = await isPasswordProtectedPdf(file);

            if (result.protected) {
              toast.error(
                "Password-protected PDFs are not supported. Please upload an unlocked file.",
              );
              return;
            }

            if (result.unverifiable) {
              toast.error(
                "Password-protected PDFs are not supported. Please upload an unlocked file.",
              );
              return;
            }
          }
        }
        let data = new FormData();
        data.append("image", e.target.files[0]);
        let res = await AuthServices.uploadImage(data);
        setuploadstatus(true);
        // setUploadedImage(uploadedImageUrl);
        // window.alert("Image uploaded successfully");
        toast.success("Image uploaded successfuly");
        setDocUrl(res?.data?.url);
        setFieldValue(fieldName, res?.data?.url);
      } catch (error) {
        handleApiErrorResponses(error);
      }
    }
  };

  return (
    <div className="upload-modal-container">
      <button type="button" className="open-btn" onClick={handleOpen}>
        <FileUploadOutlinedIcon fontSize="small" /> UPLOAD
      </button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="custom-modal"
      >
        <Box sx={style}>
          <div
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              fontFamily: "Inter, sans-serif",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <div
              className="absolute top-0 right-0 cursor-pointer"
              onClick={handleClose}
            >
              <img src={CloseIcon} alt="close-icon" />
            </div>
            <div
              style={{
                fontFamily: "inherit",
                fontSize: "24px",
                fontWeight: "600",
                color: "#191919",
              }}
            >
              Upload
              {/* {documentDetails?.documentName} */}
            </div>
            <div
              style={{
                fontFamily: "inherit",
                fontSize: "16px",
                fontWeight: "400",
                color: "#797979",
                marginTop: "16px",
              }}
            >
              {/* {documentDetails?.description}  */}
              document description
            </div>
            <button
              style={{
                height: "34px",
                width: "118px",
                borderRadius: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontFamily: "Inter, sans-serif",
                fontWeight: "600",
                fontSize: "14px",
                backgroundColor: "#017c57",
                color: "white",
                border: "none",
                gap: "8px",
                marginTop: "64px",
              }}
              onClick={() => handleButtonClick()}
            >
              <FileUploadOutlinedIcon fontSize="small" /> UPLOAD
            </button>
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
              onChange={uploadImage}
              style={{ display: "none" }}
              ref={fileInputRef}
            />
            <div
              style={{
                fontFamily: "inherit",
                fontSize: "12px",
                fontWeight: "400",
                color: "#797979",
                marginTop: "4px",
              }}
            ></div>
            {uploadstatus &&
              (() => {
                const fileType = getFileType(docUrl);

                return (
                  <>
                    {fileType === "image" && (
                      <img
                        src={docUrl}
                        alt="Document"
                        style={{
                          width: "50%",
                          height: "50%",
                          objectFit: "contain",
                        }}
                      />
                    )}

                    {fileType === "pdf" && (
                      <a href={docUrl} target="_blank">
                        <img src={PdfIcon} alt="pdf-icon" />
                      </a>
                    )}

                    {fileType === "unknown" && <p>Preview not available.</p>}
                  </>
                );
              })()}

            <button
              type="button"
              style={{
                height: "34px",
                width: "160px",
                borderRadius: "32px",
                marginTop: "64px",
                fontFamily: "Inter, sans-serif",
                textAlign: "center",
                fontWeight: "600",
                fontSize: "12px",
                backgroundColor: "white",
                color: "#017C57",
                border: "1px solid #017C57",
              }}
              onClick={() => setOpen(false)}
            >
              SAVE
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
